import {clsx} from 'clsx';
import React from 'react';

import {Config as TableSettings} from '../../../util/runfeed';
import {FilterKeySelectorCreatorProps} from '../../Filters/FilterKeySelector';
import {NamedProjectFieldSelector} from '../../ProjectFieldSelector';
import {RUNS_FILTER_DEFAULT_KEYS} from './constants';

type RunsFilterKeySelectorProps = FilterKeySelectorCreatorProps & {
  entityName: string;
  projectName: string;
  tableSettings: TableSettings;
};

export const RunsFilterKeySelector = ({
  entityName,
  projectName,
  tableSettings,
  keyValue,
  onValidSelection,
  focusOnMount,
  isValid = true,
}: RunsFilterKeySelectorProps) => {
  return (
    <NamedProjectFieldSelector
      data-test="filter-key"
      className={clsx('adjusted-chevron filter-dropdown filter-list__key', {
        invalid: !isValid,
      })}
      entityName={entityName}
      projectName={projectName}
      tableSettings={tableSettings}
      defaultKeys={RUNS_FILTER_DEFAULT_KEYS}
      focusOnMount={focusOnMount}
      closeOnChange
      selection
      multi={false}
      value={keyValue}
      setValue={onValidSelection}
      searchByKeyAndText
    />
  );
};
